import { useInView } from '../../hooks/useInView'
import { useCountUp } from '../../hooks/useCountUp'
import { GOALS, reachGoal } from '../../lib/metrika'
interface NotificationCard {
  name: string
  time: string
  action: string
  category: string
  icon: string
}

const NOTIFICATIONS: NotificationCard[] = [
  { name: 'Антон. П', time: 'Сегодня, 11:57', action: 'Забрал промокод', category: 'КИНОТЕАТРЫ', icon: '🎬' },
  { name: 'Мария. Л', time: 'Сегодня, 11:53', action: 'Подтвердила номер', category: 'КРАСОТА', icon: '💅' },
  { name: 'Анна. Г', time: 'Сегодня, 11:48', action: 'Выбрала предложение', category: 'БАНКИ', icon: '🏦' },
  { name: 'Виталий. К', time: 'Сегодня, 11:42', action: 'Оставил почту', category: 'ЕДА', icon: '🍕' },
]

export function Stats() {
  const { ref, inView } = useInView(0.2, '0px 0px -120px 0px')
  const { ref: notifRef, inView: notifInView } = useInView(0.5, '0px 0px -80px 0px')
  const count30 = useCountUp(30, 2400, inView)
  const count100 = useCountUp(100, 2400, inView)

  return (
    <section
      id="product"
      ref={ref}
      className={`mx-auto flex max-w-[1920px] flex-col items-center gap-8 px-4 py-14 sm:gap-12 sm:px-6 sm:py-20 lg:px-[7%] lg:py-28 reveal${inView ? ' in-view' : ''}`}
    >
      {/* Заголовок */}
      <div className="flex flex-col items-center gap-5 text-center">
        <span
          className="inline-block text-[12px] font-bold uppercase text-accent"
          style={{
            letterSpacing: '2px',
            lineHeight: '24px',
            fontFamily: 'Helvetica, Arial, Inter, system-ui, sans-serif',
          }}
        >
          О&nbsp;продукте&nbsp;&nbsp;Ris&nbsp;promo
        </span>
        <h2 className="font-display text-[28px] max-[359px]:text-[24px] font-semibold leading-[1.14] text-[#041527] sm:text-[44px] lg:text-[56px] lg:leading-[64px]">
          Охваты, которые работают
          <br />
          на&nbsp;ваш бизнес
        </h2>
        <p className="font-body max-w-[820px] text-[15px] leading-[23px] text-[#676b94] sm:text-[16px] sm:leading-[26px] lg:text-[20px] lg:leading-[30px]">
          Показывайте свои предложения тёплой аудитории партнёров.
          <br className="hidden sm:inline" />
          <span className="sm:hidden"> </span>
          Алгоритмы платформы сами найдут ваших будущих клиентов&nbsp;— достаточно просто запустить акцию.
        </p>
      </div>

      {/* Картинка-блок: карточка + CTA снизу */}
      <div className="flex w-full flex-col items-center gap-5">
        {/* Голубая карточка */}
        <div
          className="relative w-full overflow-hidden rounded-[28px] min-[1440px]:h-[521px]"
          style={{
            background: 'linear-gradient(180deg, #E8F1FC 0%, #D5E5F8 50%, #E3EEF9 100%)',
          }}
        >
          {/* Серый «iPhone-скрин» */}
          <div
            aria-hidden
            className="pointer-events-none absolute left-1/2 top-0 hidden -translate-x-1/2 rounded-[37px] bg-[#f0f1f5] min-[1440px]:block"
            style={{ width: '300px', height: '603px' }}
          />

          {/* Цифры со счётчиком */}
          {/* Оверлей с абсолютным позиционированием — только с 1440px: уже
              колонка уведомлений в центре наезжает на цифры по краям. */}
          <div className="flex w-full justify-center gap-12 px-2 py-6 text-left min-[1440px]:absolute min-[1440px]:inset-x-0 min-[1440px]:top-[185px] min-[1440px]:flex min-[1440px]:flex-row min-[1440px]:items-start min-[1440px]:justify-between min-[1440px]:gap-0 min-[1440px]:px-[102px] min-[1440px]:py-0">
            <div className="flex flex-col gap-1 lg:gap-2.5">
              <p
                className="font-display font-bold text-[#1d1e20]"
                style={{ fontSize: 'clamp(36px, 9vw, 80px)', letterSpacing: '-0.045em', lineHeight: 1 }}
              >
                {count30}+&nbsp;<span style={{ fontSize: '0.75em' }}>млн</span>
              </p>
              <p className="font-body text-[15px] font-normal leading-snug text-black lg:text-[20px] lg:leading-7">
                Пользователей
                <br />в&nbsp;партнёрской<br className="sm:hidden" /> сети
              </p>
            </div>
            <div className="flex flex-col gap-1 lg:gap-2.5">
              <p
                className="font-display font-bold text-[#1d1e20]"
                style={{ fontSize: 'clamp(36px, 9vw, 80px)', letterSpacing: '-0.045em', lineHeight: 1 }}
              >
                {count100}+
              </p>
              <p className="font-body text-[15px] font-normal leading-snug text-black lg:text-[20px] lg:leading-7">
                Предложений
                <br />в&nbsp;20&nbsp;разных<br className="sm:hidden" /> категориях
              </p>
            </div>
          </div>

          {/* Уведомления — stagger-анимация снизу вверх */}
          <div ref={notifRef} className="relative mx-auto flex w-full max-w-[370px] flex-col gap-3 px-4 pb-6 min-[1440px]:absolute min-[1440px]:left-1/2 min-[1440px]:top-3 min-[1440px]:max-w-none min-[1440px]:w-[370px] min-[1440px]:-translate-x-1/2 min-[1440px]:py-0">
            {NOTIFICATIONS.map((n, i) => (
              <NotificationCardItem
                key={n.name}
                {...n}
                index={i}
                inView={notifInView}
              />
            ))}
          </div>
        </div>

        {/* CTA */}
        <a
          href="https://lk.ris.promo/auth/register"
          onClick={() => reachGoal(GOALS.signupClick, { place: 'секция о продукте' })}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center rounded-full px-5 py-2.5 text-[16px] font-medium text-[#fcfcfc] transition duration-300 ease-out hover:brightness-110 active:brightness-90"
          style={{ background: 'linear-gradient(180deg, #0d6fe0 0%, #145aff 100%)' }}
        >
          Создать аккаунт
        </a>
      </div>
    </section>
  )
}

function NotificationCardItem({
  name, time, action, category, icon, index, inView,
}: NotificationCard & { index: number; inView: boolean }) {
  return (
    <div
      className="rounded-[16px] bg-white px-5 py-4"
      style={{
        boxShadow: '0 1px 2px rgba(15,31,61,0.04), 0 6px 16px -4px rgba(15,31,61,0.08)',
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(20px)',
        transition: `opacity 0.6s cubic-bezier(0.45, 0, 0.15, 1) ${index * 200}ms, transform 0.6s cubic-bezier(0.45, 0, 0.15, 1) ${index * 200}ms`,
      }}
    >
      <div className="font-display flex items-center justify-between text-[13px] font-semibold text-[#676b94]">
        <span>{name}</span>
        <span>{time}</span>
      </div>
      <div className="my-3 h-px w-full bg-[#eef0f5]" />
      <div className="flex items-center justify-between gap-3">
        <span className="font-display text-[16px] font-semibold text-[#041527]">
          {action}
        </span>
        <span className="font-display flex h-[37px] shrink-0 items-center gap-[9px] rounded-[8px] bg-[#eef2ff] px-[11px] text-[13px] font-bold uppercase leading-none text-[#1f284e]">
          <span className="text-[18px] leading-none">{icon}</span>
          {category}
        </span>
      </div>
    </div>
  )
}
